import moment from "moment";
import { Option } from "../../helpers/helpers";

type RangeResult = {
    from: number;
    to: number;
};

export const handleRangeSelect = (option?: Option): RangeResult | undefined => {
    if (!option) return;

    const now = moment();
    let from: moment.Moment;

    switch (option.id) {
        case 1: // Last 24 hours
            from = moment().subtract(24, "hours");
            break;
        case 2: // Last 7 days
            from = moment().subtract(7, "days");
            break;
        case 3: // Last 1 month
            from = moment().subtract(1, "months");
            break;
        default:
            return;
    }

    return {
        from: from.unix(),
        to: now.unix(),
    };
};
